import { DirectSalesSweep } from 'components/common/types/DirectSalesCampaign.types';
import { ProductTemplateRulesResponse } from 'components/common/types/DirectSalesProductTemplate.types';
import { ProductManagement, SelectionPermission } from 'store/productManagement/reducer.types';

export const transformSweepFromResponse = (
  sweepRule: ProductTemplateRulesResponse,
  sweepPermission: SelectionPermission,
): ProductManagement['newProduct']['sweep'] => {
  if (sweepPermission === SelectionPermission.DISABLED) {
    return undefined;
  }

  if (sweepRule.behaviour === 'FIXED') {
    return {
      selectionPermission: sweepPermission,
      value: sweepRule.fixedSet[0] as DirectSalesSweep,
    };
  }

  return { selectionPermission: sweepPermission, value: undefined };
};
